import { CatalogType, CatalogValueType } from "@/types/catalogType";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useCatalogStore = defineStore(
  "catalog",
  () => {
    const catalog = ref<CatalogType>({
      condicionPago: [] as CatalogValueType[],
      formaPago: [] as CatalogValueType[],
      origenCuenta: [] as CatalogValueType[],
      relacionTercero: [] as CatalogValueType[],
      tipoCuenta: [] as CatalogValueType[],
      tipoMovimiento: [] as CatalogValueType[],
      tipoOperacion: [] as CatalogValueType[],
      tipoTercero: [] as CatalogValueType[],
    });

    return {
      catalog,
    };
  },
  {
    persist: true,
  }
);
